<template>
  <div
    :class="[
      'right-box',
      drawerState ? 'active' : 'showactive',
      showGlass ? 'glass' : '',
    ]"
    :style="{ background: !backColor ? '' : backColor }"
  >
    <div class="drawer-btn" @click="drawer">
      <div :class="{ rotateIcon: drawerState }">
        <img
          class="gross"
          src="https://images.jianshankeji.com/timepark_gross.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "rightBox",
  props: {
    showGlass: {
      //是否显示毛玻璃
      default: true,
      type: Boolean,
    },
    backColor: {
      //不显示玻璃之后的颜色
      default: "",
      type: String,
    },
  },
  data() {
    return {
      drawerState: false,
    };
  },
  mounted() {
    console.log(1111, this.backColor);
  },
  methods: {
    drawer() {
      this.drawerState = !this.drawerState;
    },
  },
};
</script>

<style lang="scss">
.right-box {
  width: 170px;
  height: 100vh;
  position: fixed;
  right: -150px;
  top: 0;
  transition: all 0.3s;
  transform: translateX(150px);
  padding: 0 19px;
  z-index: 10;
  box-sizing: border-box;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // align-content: center;

  .drawer-btn {
    position: absolute;
    top: 40px;
    left: 0;
    transform: translateX(-50%);
    width: 21px;
    height: 21px;
  }
}

.active {
  transform: translateX(0px);
}

.showactive {
  transform: translateX(-150px);
}

.glass {
  background: rgba(130, 130, 130, 0.05);
  backdrop-filter: blur(5px);
}

.rotateIcon {
  transform: rotate(180deg);
}
.gross {
  width: 21px;
  height: 21px;
  display: block;
}
</style>
